import React, { useEffect, useState } from 'react';

import { Box } from '@material-ui/core';
import { useFormContext } from 'react-hook-form';

import { ScheduleType } from '../../../../modules/timeModule/constants';
import { OnboardingStepTitle } from '../../../../components';
import { WeekHours } from '../../components/WeekHours';
import { useShiftLabel } from '../hooks/useShiftLabel';

interface Props {
  type: ScheduleType;
  shiftFieldName: string;
  shiftIndex: number;
}

export const ScheduleHoursStep: React.FC<Props> = ({ type, shiftFieldName, shiftIndex }) => {
  const scheduleDetailsFieldName = `${shiftFieldName}.${type}`;
  const { watch, setValue, getValues } = useFormContext();
  const [overlappingDays, setOverlappingDays] = useState<string[]>([]);
  const shiftLabel = useShiftLabel(shiftFieldName, shiftIndex);

  const startTimeField = `${scheduleDetailsFieldName}.startTime`;
  const endTimeField = `${scheduleDetailsFieldName}.endTime`;
  const startTime = watch(startTimeField);
  const endTime = watch(endTimeField);
  const scheduleFieldName = `${scheduleDetailsFieldName}.schedule`;
  const scheduleToCompare = watch(
    `${shiftFieldName}.${
      type === ScheduleType.OVERTIME ? ScheduleType.REGULAR : ScheduleType.OVERTIME
    }.schedule`
  );

  useEffect(() => {
    const newSchedule: any = { ...getValues(scheduleFieldName) };

    Object.keys(newSchedule).forEach(key => {
      if (key !== 'sunday' && key !== 'saturday') {
        if (startTime) {
          newSchedule[key].start = startTime;
        }
        if (endTime) {
          newSchedule[key].end = endTime;
        }
      }
    });

    setValue(scheduleFieldName, newSchedule);
  }, [startTime, endTime]);

  return (
    <>
      <OnboardingStepTitle text={`Let’s customise paid ${type} hours${shiftLabel} for each day.`} />

      <Box marginTop={2}>
        <WeekHours
          overlappingDays={overlappingDays}
          setOverlappingDays={setOverlappingDays}
          scheduleToCompare={scheduleToCompare}
          scheduleType={type}
          inputLabel="Paid"
          scheduleDetailsFieldName={scheduleDetailsFieldName}
        />
      </Box>
    </>
  );
};
